import {isIOS} from 'react-device-detect';

const isLandscape = () => {

    return isIOS ? document.documentElement.clientWidth > document.documentElement.clientHeight : screen.width > screen.height;

}

export default isLandscape;